import { graphql } from 'react-relay';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import type {
	preloadLegacyBridgeQuery$data,
	preloadLegacyBridgeQuery$variables,
} from './__generated__/preloadLegacyBridgeQuery.graphql.ts';

/**
 * see next/packages/view-page/src/LegacyBridgeNextInner.tsx for the query usage
 */
const PreloadLegacyBridgeQuery = graphql`
	query preloadLegacyBridgeQuery($contentId: ID!, $isBlog: Boolean!) {
		# ptpage doesn't work for blog posts. It will return 404
		ptpage(id: $contentId, status: [CURRENT]) @skip(if: $isBlog) {
			id
			nearestAncestors(first: 1) {
				edges {
					node {
						id
						title
					}
				}
			}
		}
		content(id: $contentId) {
			nodes {
				id
				type
				title
				version {
					number
				}
				space {
					id
					key
					name
					type
				}
				operations {
					operation
					targetType
				}
			}
		}
	}
`;

export async function preloadLegacyBridge({
	contentId,
	isBlog,
}: {
	contentId: string;
	isBlog: boolean;
}): Promise<
	| {
			data: preloadLegacyBridgeQuery$data | null;
			errors?: ReadonlyArray<GraphQLErrorInterop>;
			hasErrors: boolean;
	  }
	| undefined
> {
	if (!contentId) {
		return;
	}

	return query<preloadLegacyBridgeQuery$data, preloadLegacyBridgeQuery$variables>({
		query: PreloadLegacyBridgeQuery,
		variables: { contentId, isBlog },
		errorPolicy: 'all',
	});
}
